import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IContractItem } from 'src/app/state/contracts/contracts.models';

@Component({
  selector: 'app-policy-list-item',
  templateUrl: './policy-list-item.component.html',
  styleUrls: ['./policy-list-item.component.scss'],
})
export class PolicyListItemComponent {
  @Input() policy: IContractItem;
  @Input() layout: string;

  @Output() onClick: EventEmitter<IContractItem> = new EventEmitter<IContractItem>();

  // Methods
  select_policy() {
    this.onClick.emit(this.policy);
  }

  get_class_by_name() {

    if (this.policy.policy) {
      return 'blue';
    } else {
      if (
        this.policy.quotation.data.estadoInterno === 'Proyecto' &&
        this.policy.quotation.data.autorizada === true
      ) {
        return 'red';
      } else if (
        this.policy.quotation.data.estadoInterno === 'Proyecto' &&
        this.policy.quotation.data.autorizada != true
      ) {
        return 'yellow';
      }
    }
  }
}
